﻿import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
//import { DocumentationConstants } from '../store/documentation-constants';
import DmaFooter from '../DmaFooter';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import { Entity } from '../../models/entity';
import { SerializationRequest } from '../../models/Serialization/serialization-request';
import { Entities, MessageBoxReplyType } from '../../models/enums';
import { CrudFunctions } from '../../utilities/crud-functions';

import DataGrid, {
    Column,
    FilterRow,
    GroupPanel,
    Selection,
    HeaderFilter,
    Editing,
    Popup,
    Form,
    Toolbar,
    Item as ToolBarItem,
    Button as ColumnButton,
    Paging,
    Scrolling,
    Lookup,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import List from 'devextreme-react/list';
import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Toast } from 'devextreme-react/toast';

export default function DmaSerializationForm() {
    const [entities, setEntities] =
        useState<Entity[]>();

    const [entity, setEntity] =
        useState<Entity>();

    const [serializationRequests, setSerializationRequests] =
        useState<SerializationRequest[]>([]);

    const [toastVisible, setToastVisible] =
        useState<boolean>();

    const [toastMessage, setToastMessage] =
        useState<string>();

    const [toastType, setToastType] =
        useState<any>();

    const [searchRowPointer, setSearchRowPointer] =
        useState<string>();

    const [searchIdLabel, setSearchIdLabel] =
        useState<string>();

    const [searchNameLabel, setSearchNameLabel] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    const gridWidth = 'calc(90vw - 13em)';

    return (
        <div className="pw-form-container">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Serialization</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back" className="title-bar-button"
                            height={'2.6em'}
                            onClick={goBack} />
                    </div>
                    {/*
                        <div>
                            <NavLink to={`/documentation/${DocumentationConstants.GlasswareForm}`}
                                className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                                <Button className="title-bar-button pw-orange"
                                    text="" icon="help" type="normal"
                                    hint="help and documentation" />
                            </NavLink>
                        </div>
                        */}
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">Entity</label>
                    <SelectBox
                        dataSource={entities ? entities : []}
                        onValueChanged={onEntitySelectionChanged}
                        displayExpr='label'
                        value={entity ? entity : undefined} />

                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <label className="textbox-label">{searchIdLabel ? searchIdLabel : 'Entity Row Pointer'}</label>
                    <TextBox id="searchId" className="textbox"
                        showClearButton={true}
                        placeholder="search id"
                        onValueChanged={(e: any) => setSearchRowPointer(e.value)}
                        value={searchRowPointer ? searchRowPointer : undefined} />
                </div>

                <Button id="serializeButton" text="Serialize" icon="find" type="success"
                    hint="serialize"
                    height='1.6rem'
                    className="pw-row-button-2"
                    onClick={onAddRequestButtonClick} />
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-30">
                    <label className="textbox-label">Requests</label>
                    <List height="20rem"
                        className="dx-listbox"
                        onItemClick={onRequestListBoxItemClick}
                        dataSource={serializationRequests} />
                </div>
            </div>

            {/* itemRender={userGroupUsersRender}
                */}

            <Button id="serializeButton" text="Serialize" icon="find" type="success"
                hint="serialize"
                height='1.6rem'
                className="pw-row-button-2"
                onClick={onGetSerializationButtonClick} />

        </div>
    );


    function onRequestListBoxItemClick(e: any) {


    }

    function onAddRequestButtonClick() {
        let newRequests = [...serializationRequests];

        let serializationRequest: SerializationRequest = {
            entity: entity,
            rowPointer: searchRowPointer
        };

        console.log("onGetSerializationClick");
        console.log(serializationRequest);

        newRequests.push(serializationRequest);

        setSerializationRequests(newRequests);
    }

    async function onGetSerializationButtonClick() {
        sendSerializationRequests();
    }
    
    function onEntitySelectionChanged(e: any) {
        if (e.value && e.value.entityId && entities) {
            const entityId = e.value.entityId;

            const selectedEntity =
                entities.filter(ent => ent.entityId === entityId);

            console.log("selectedEntity:");
            console.log(selectedEntity);

            if (selectedEntity && selectedEntity.length > 0) {
                setEntity(selectedEntity[0]);
            }
        }
    }

    async function sendSerializationRequests() {
        if (serializationRequests) {
            await getEntitySerialization(serializationRequests)
                .then((data) => {




                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Serialized Entities");
                });
        }
    }

    // GET functions

    async function getEntities() {
        await CrudFunctions.getData("common/entities")
            .then(data => {

                console.log("returned entities...");
                console.log(data);

                //temp for Phase 1
                let returnedEntities = data as Entity[]

                if (returnedEntities) {
                    const phase1Entities = ['AnalyticalPlans', 'Assets', 'BatchPlanning', 'BatchProductions', 'GasChromatographyAssets', 'Products', 'RawMaterials'];

                    const allEntities = returnedEntities.filter((i: any) =>
                        phase1Entities.includes(i.name)
                    );

                    setEntities(allEntities);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving Entities");
            });
    }

    async function getEntitySerialization(requests: SerializationRequest[]) {
        await CrudFunctions.postDataBlob("serialization/serializeentity", requests)
            .then((blob: any) => {
                let a = document.createElement("a") as HTMLAnchorElement;

                document.body.appendChild(a);
                a.style.display = "none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                //todo:
                a.download = "DmaSerialization.json";
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Serializing Entity");
            });

        //to open PDF in browser:
        // let file = window.URL.createObjectURL(blob);
        // window.open(file, "_blank");

        //return await CrudFunctions.postData("serialization/serializeentity", request);
    }

    async function getAllData() {
        await getEntities();

    }

    function goBack() {
        history.back();
    }


    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }


    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
